module.exports = __webpack_public_path__ + "static/sd-voyager-banner-a2578ba107a3f5b1cc4c7f1ad65b831e.png";